<div class="modal-body text-center px-4 py-4" ngbAutofocus>
  <button *ngIf="showCloseIcon" type="button" class="modal-close-icon" (click)="closeModal()" aria-label="Close">
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor"
      stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      <line x1="18" y1="6" x2="6" y2="18" />
      <line x1="6" y1="6" x2="18" y2="18" />
    </svg> </button>

  <div class="warning-icon mx-auto mb-3" *ngIf="isDanger">
    <i class="bi bi-exclamation-triangle-fill"></i>
  </div>
  <div class="lock-icon mx-auto mb-3" *ngIf="isBindRequest">
    <svg width="23" height="23" viewBox="0 0 15 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.6667 7.49967V4.99967C11.6667 2.69849 9.80123 0.833008 7.50004 0.833008C5.19885 0.833008 3.33337 2.69849 3.33337 4.99967V7.49967M4.83337 15.833H10.1667C11.5668 15.833 12.2669 15.833 12.8017 15.5605C13.2721 15.3208 13.6545 14.9384 13.8942 14.468C14.1667 13.9332 14.1667 13.2331 14.1667 11.833V11.4997C14.1667 10.0995 14.1667 9.39948 13.8942 8.8647C13.6545 8.39429 13.2721 8.01184 12.8017 7.77216C12.2669 7.49967 11.5668 7.49967 10.1667 7.49967H4.83337C3.43324 7.49967 2.73318 7.49967 2.1984 7.77216C1.72799 8.01184 1.34554 8.39429 1.10586 8.8647C0.833374 9.39948 0.833374 10.0995 0.833374 11.4997V11.833C0.833374 13.2331 0.833374 13.9332 1.10586 14.468C1.34554 14.9384 1.72799 15.3208 2.1984 15.5605C2.73318 15.833 3.43324 15.833 4.83337 15.833Z"
        stroke="#0f9703" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
  </div>

  <h5 class="fw-semibold mb-2 title">{{ title }}</h5>

  <p *ngIf="!isHtml" class="message mb-2">{{ message }}</p>
  <p *ngIf="isHtml" class="message mb-2" [innerHTML]="message"></p>

<div class="d-flex justify-content-center gap-2 mt-4" [class.compact-actions]="compactActions">
  <button *ngIf="showCancel" class="outline btn md px-4" (click)="cancel()">
    {{ cancelText }}
  </button>

  <button btn class="px-4" *ngIf="confirmText"
    [ngClass]="isContactSupport ? 'outline btn md cancel-btn' : (isDanger ? 'danger btn md' : 'btn primary btn md')"
    (click)="confirm()">
    {{ confirmText }}
  </button>
</div>

</div>